import React from 'react';

import { useGraphQLQuery } from '@betterment/graphql';
import { useAutoNavigate } from '@betterment/js-runtime';
import { Box } from '@betterment/samba-react';
import { InlineWidget, useCalendlyEventListener } from 'react-calendly';

import { WorkflowLayout } from '../../Shared/layout/WorkflowLayout';
import { ScheduledEventConfigurationDocument } from '../graphql/query.scheduledEventConfiguration.generated';

import type { StepProps } from '@betterment/js-runtime';

export const ScheduleMeetingStep: React.FC<StepProps> = ({ flowState, goToNextStep }) => {
  const navigate = useAutoNavigate();

  const { data } = useGraphQLQuery(ScheduledEventConfigurationDocument, {
    variables: { scheduleEvent: 'betterment_advisor_network' },
    throwOnError: true,
  });

  useCalendlyEventListener({
    onEventScheduled: e => {
      goToNextStep();
    },
  });

  if (data?.financialServiceOptions?.[0].__typename !== 'BettermentAdvisorNetworkOption') {
    return null;
  }

  const {
    scheduledEventConfiguration: { calendarLink },
  } = data.financialServiceOptions[0];

  return (
    <WorkflowLayout
      feature="advisor_network"
      pageTitle="Schedule Appointment"
      workflowTitle=""
      onClose={() => navigate(flowState.returnToPath)}
      size="full"
    >
      <Box
        css={{
          display: 'flex',
          flexDirection: 'column',
          gap: 'space.300',
          width: '100%',
          maxWidth: '1000px',
          margin: '0 auto',
        }}
        id="calendly-wrapper"
      >
        <InlineWidget
          url={calendarLink}
          styles={{
            width: '100%',
            height: '700px',
          }}
        />
      </Box>
    </WorkflowLayout>
  );
};
